// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"5dd67e12","166":"e1394d94","182":"39821840","241":"03b476c3","309":"1c44ef51","370":"038f002a","418":"d99904a1","419":"7406f290","982":"5cd98aa5","989":"89bb0171"}[chunkId] + ".chunk.js";
};